import { Controller } from 'stimulus'
import Sortable from 'sortablejs'

export default class extends Controller {
  static targets = ['element']
	connect() {
		this.sortable = Sortable.create(this.element, {
      group: 'deal-elements',
      direction: 'horizontal',
      animation: 250,
      swapThreshold: 0.85,
      filter: '.deal-card--restricted',
      onEnd: this.end.bind(this),
    })
  }

  end(event) {
    let currentFileTemplate = event.item
    let currentFileRequirements = JSON.parse(currentFileTemplate.dataset.requirements)
    if (currentFileTemplate.parentElement.dataset.type === 'active') {
      currentFileTemplate.classList.add('deal-card--selected');
      let hiddenFields = currentFileTemplate.getElementsByTagName("input");
      if (hiddenFields.length === 0){
        let input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", "deal_stage[element_ids][]");
        input.setAttribute("value", `${currentFileTemplate.dataset.id}`);
        input.setAttribute("id", `deal_stage_element_ids_${currentFileTemplate.dataset.id}`);
        currentFileTemplate.appendChild(input);
      }
    } else {
      currentFileTemplate.classList.remove('deal-card--selected');
      let hiddenFields = currentFileTemplate.getElementsByTagName("input");
      while (hiddenFields.length > 0){
        hiddenFields[0].remove();
      }
    }
    for (let element of $('element')) {
      let otherFileRequirements = JSON.parse(element.dataset.requirements)
      if (element.parentElement.dataset.type === 'other') {
        let hiddenFields = element.getElementsByTagName("input");
        while (hiddenFields.length > 0){
          hiddenFields[0].remove();
        }
        element.classList.remove('deal-card--selected');
        if (currentFileRequirements.length > 0) {
          for (let othr of otherFileRequirements) {
            if (currentFileRequirements[0][0] !== othr[0] && 
                currentFileRequirements[0][1] === othr[1] && 
                element.classList.contains('deal-card--restricted')) {
              element.classList.remove('deal-card--restricted');
            }
          }
        }
      } else {
        if (currentFileRequirements.length > 0) {
          for (let othr of otherFileRequirements) {
            if (currentFileRequirements[0][0] !== othr[0] &&
                currentFileRequirements[0][1] === othr[1] &&
                !element.classList.contains('deal-card--restricted')) {
                element.classList.add('deal-card--restricted');
            }
          }
        }
      }
    }
  }
}
